/*eslint no-extend-native:0 */
define('glu/promise',['require','rsvp','./appBus'],function(require) {
    'use strict';

    var RSVP = require('rsvp'),
        appBus = require('./appBus');

    // Mimic native Promises, by only exposing `Promise` and `Promise.all`
    var Promise = RSVP.Promise;

    Promise.prototype.all = RSVP.all;

    // We also expose `Promise.hash` as this is a particularly tasty bit of synatic sugar
    Promise.hash = RSVP.hash;

    RSVP.on('error', function(err) {
        appBus.trigger('promise:error', err);
    });

    return Promise;
});

